import type { InputProps } from '@chakra-ui/react';
import { Flex, Input, InputElement } from '@chakra-ui/react';
import { MaskIcon } from '@ui/components/MaskIcon';
import { debounce } from 'lodash-es';
import type { FC } from 'react';
import { useMemo, useState } from 'react';

import { useAgentsView } from './useAgentsView';

export const SearchInput: FC<InputProps> = (props) => {
  const isSearchInputShown = useAgentsView((s) => s.isSearchInputShown);
  const [inputValue, setInputValue] = useState('');

  const setSearchValue = useMemo(() => {
    return debounce((value: string) => {
      useAgentsView.setState({
        search: value,
      });
    }, 1_000);
  }, []);

  if (!isSearchInputShown) return null;

  return (
    <Flex
      position="relative"
      maxW={{
        desktop: '500px',
      }}
    >
      <InputElement pointerEvents="none">
        <MaskIcon icon="url(/masks/search.svg)" bgColor="text.default" />
      </InputElement>
      <Input
        value={inputValue}
        flex="1"
        variant="flushed"
        placeholder="Search for agent..."
        autoFocus
        px="40px"
        onChange={(e) => {
          setInputValue(e.target.value);
          setSearchValue(e.target.value);
        }}
        {...props}
      />
      <InputElement
        placement="end"
        cursor="pointer"
        onClick={() => {
          setInputValue('');
          setSearchValue('');
        }}
      >
        <MaskIcon icon="url(/masks/close.svg)" bgColor="text.default" />
      </InputElement>
    </Flex>
  );
};
